import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=cd37c082&scoped=true"
import script from "./RegisterResult.vue?vue&type=script&lang=js"
export * from "./RegisterResult.vue?vue&type=script&lang=js"
import style0 from "./RegisterResult.vue?vue&type=style&index=0&id=cd37c082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd37c082",
  null
  
)

export default component.exports